import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { selectPayment } = actions;

const useGetPaymentMethodSelected = () => {
  const dispatch = useDispatch();
  const paymentReducer = useSelector((state) => state.paymentReducer);
  const { isFetchedListCard, isFetchingListCard, listCard, paymentSelected } = paymentReducer;

  useEffect(() => {
    if (listCard.length === 0) {
      dispatch(selectPayment({ payload: {} }));
    }
    if (listCard.length > 0) {
      dispatch(selectPayment({ payload: listCard[0] }));
    }
  }, [dispatch, isFetchedListCard, listCard]);

  return useMemo(() => {
    return {
      paymentSelected,
      isFetchingListCard,
    };
  }, [isFetchingListCard, paymentSelected]);
};

export default useGetPaymentMethodSelected;
